import type { FC } from "react";
import { Banner } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";

/**
 * Where access that report emails can't reach comes from:
 *
 * - `"support"`: the support role, which makes the user a tenant admin.
 * - `"microsoftGroup"`: a Microsoft (Entra) group, carried in the sign-in token.
 */
export type ReportEmailAccessBannerReason = "support" | "microsoftGroup";

export interface ReportEmailAccessBannerProps {
  readonly reason: ReportEmailAccessBannerReason;
}

const MESSAGES: Readonly<Record<ReportEmailAccessBannerReason, string>> = {
  support:
    "You can see this report through the support role, so you won't get these emails. Grant yourself access in Users & Permissions to receive them.",
  microsoftGroup:
    "You can see this report through a Microsoft group, so you won't get these emails. Grant yourself access in Users & Permissions to receive them.",
};

/**
 * Why this user won't get the report emails they set up. Access from either
 * source is granted per request and never stored, and the sender only emails
 * users who pass the reports gate from stored grants.
 */
export const ReportEmailAccessBanner: FC<ReportEmailAccessBannerProps> = ({ reason }) => (
  <Banner variant="warning" message={MESSAGES[reason]} />
);
